import { AppstoreAddOutlined, LogoutOutlined } from "@ant-design/icons"
import { Button, Dropdown, MenuProps, Typography } from "antd"
import { useAuth } from "oidc-react";
import { useNavigate } from "react-router-dom";
import ImageLogo from '../../../assets/Images/logo_fi_mini.png';
import './appBar.css';

export default function AppBar() {

    const { signOutRedirect, userManager, userData } = useAuth()
    const router = useNavigate()

    const finalName = userData?.profile.given_name ? userData?.profile.given_name.charAt(0).toUpperCase() + userData?.profile.given_name.slice(1).toLowerCase() : "Não Identificado"

    const redirectFiConnect = () => {
        router(`https://connect.fi-group.com/identity/`)
    }

    const Logout = () => {
        signOutRedirect(userManager.settings.authority?.toString())
    }

    const items: MenuProps['items'] = [
        {
            type: 'divider',
        },
        {
            key: '6',
            label: <Typography style={{ color: '#00AEFF' }}>Sair</Typography>,
            icon: <LogoutOutlined style={{ color: '#00AEFF' }} />,
            onClick: () => {
                Logout()
            }
        }
    ];

    return (
        <>
            <div className="appBar-container">
                <div style={{ height: '45px', width: '100%', background: 'white', display: 'flex', alignItems: 'center', borderBottom: '1px solid rgba(210, 210, 210, 0.4)' }}>
                    <div className="logo-container">
                        <img className="logo-img" src={ImageLogo} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', height: '100%', borderRadius: '25px 0px 0px 0px', background: 'white', gap: '15px' }}>

                        <Typography style={{ margin: '0px auto 0px 15px', color: '#40A3FF', textTransform: "uppercase", fontSize: '20px', display: 'flex', fontWeight: 'normal', cursor: 'default', userSelect: 'none' }}>
                            Lei de TICs
                        </Typography>

                        <div className="name-container">
                            <Button onClick={() => redirectFiConnect()} icon={<AppstoreAddOutlined />} type="text" iconPosition={'start'}>Apps FI Connect</Button>

                            <Dropdown menu={{ items }}>
                                <Typography style={{ marginRight: '25px', color: '#000000A6', cursor: 'pointer' }}>Olá, {finalName}</Typography>
                            </Dropdown>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}